import React, { useState, useEffect, useRef } from 'react';
import styles from './CustomDropdown.module.css';

const CustomDropdown = ({
  label,
  value,
  options,
  onChange,
  disabled,
  placeholder = 'Select an option',
  error,
  name = 'value', // Add name prop to make dropdown reusable
  buttonClassName = '',
  isText = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className={styles.inputGroup}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.dropdownContainer} ref={dropdownRef}>
        <button
          type="button"
          className={`${styles.dropdownButton} ${error ? styles.inputError : ''} ${disabled ? styles.disabled : ''} ${buttonClassName}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
        >
          <span className={styles.dropdownValue}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <svg
            className={`${styles.dropdownIcon} ${isOpen ? styles.dropdownIconOpen : ''}`}
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              d="M1 1.5L6 6.5L11 1.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {isOpen && !disabled && (
          <div className={styles.dropdownMenu}>
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`${styles.dropdownOption} ${value === option.value ? styles.dropdownOptionSelected : ''}`}
                onClick={() => {
                  onChange(name, option.value);
                  setIsOpen(false);
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
      {isText ? (
        <div className={styles.dropdownTextContainer}>
          {options.map((option, index) =>
            value === option.value ? (
              <div key={index} className={styles.dropdownText}>
                {option.text}
              </div>
            ) : null
          )}
        </div>
      ) : null}
    </div>
  );
};

export default CustomDropdown;
